<script lang="typescript">
  /** Imports */
  import { onMount } from "svelte";
  import {
    AnomaliesView,
    ConfigView,
    InitView,
    RulesView,
    WALinesView,
  } from "./views";
  import { Router } from "./components";
  import { RouteNames, RouteSystem } from "./systems/route.system";
  import Modal from "shared/modal.svelte";
  //drawer
  import Drawer from "shared/drawer.svelte";
  import * as DrawerSystem from "shared/systems/drawer.system";

  //drawer
  import AppBar from "shared/app-bar.svelte";
  import * as AppBarSystem from "shared/systems/app-bar.system";

  import {
    AnomalyIcon,
    ConfigIcon,
    ReportIcon,
    RuleIcon,
  } from "./components/icons";

  // Routes
  const routes = {};
  routes[RouteNames.Init] = InitView;
  routes[RouteNames.Configs] = ConfigView;
  routes[RouteNames.Rules] = RulesView;
  routes[RouteNames.Anomalies] = AnomaliesView;

  routes[RouteNames.WALines] = WALinesView;

  // Left Menu Items
  let menuItems: DrawerSystem.IMenuItem[] = [
    {
      icon: RuleIcon,
      text: "Regras",
      action: () => RouteSystem.push(RouteNames.Rules),
    },
    {
      icon: AnomalyIcon,
      text: "Anomalias",
      action: () => RouteSystem.push(RouteNames.Anomalies),
    },
    {
      icon: ConfigIcon,
      text: "Configurações",
      action: () => RouteSystem.push(RouteNames.Configs),
    },
  ];

  onMount(async () => {
    DrawerSystem.setItems(menuItems);
    DrawerSystem.select(0);

    setTimeout(() => {
      AppBarSystem.setState("show");
      AppBarSystem.setTitle("Time Checher");
      DrawerSystem.setState("collapsed");
    }, 2000);
    RouteSystem.setRouter(routes);
  });
</script>

<div class="shell">
  <Modal />
  <AppBar />
  <div class="container">
    <Router />
  </div>
</div>

<style>
  @import "./reset.css";

  :root {
    --color-primary: #ffd82b;
    --color-primary-value: 61, 138, 253;
    --color-primary-light: #75a8f5;
    --color-primary-dark: #2f6cc9;

    --color-secondary: #bd54fa;
    --color-thirdary: #e47c37;
    --color-success: #8bc34a;
    --color-success-light: #b4e6a1;
    --color-warning: #ffc107;
    --color-warning-light: #eee8a7;
    --color-info: #72b9f3;
    --color-info-light: #e1f5fe;
    --color-alert: #fe8db3;
    --color-alert-light: #fce4ec;

    --color-info-strip: repeating-linear-gradient(
  to right,
  var(--color-info),
  var(--color-info) 10px,
  var(--color-info-light) 10px,
  var(--color-info-light) 20px
);

    --color-holders: #4391bd;

    --color-level-0: #121212;
    --color-level-1: #212121;
    --color-level-2: #303030;
    --color-level-3: #424242;
    --color-level-4: #525252;
    --color-level-5: #636363;
    --color-level-6: #727272;
    --color-level-7: #9b9b9b;
    --color-level-8: #d3d3d3;
    --color-level-9: #ececec;
    --color-folder: #ab8c22;

    --color-container: #252525;
    --color-header: #002d50;
    --color-background: #f6f7f9;
  }

  :global(html),
  :global(body) {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  /* :global(html) {
  } */

  :not(input):not(textarea),
  :not(input):not(textarea)::after,
  :not(input):not(textarea)::before {
    cursor: default;
  }

  .shell {
    display: flex;
    flex-direction: column;
  }

  .container {
    height: 100%;
    width: 100%;
    display: flex;
    background: var(--color-level-0);
    overflow: hidden;
  }

  :global(html, body, .shell) {
    height: 100%;
    width: 100%;
    font-family: "Roboto", sans-serif;
    overflow: hidden;
  }

  :global(::-webkit-scrollbar) {
    width: 10px;
    background: transparent;
    height: 10px;
  }

  :global(::-webkit-scrollbar-thumb) {
    background: var(--color-level-4);
    border-radius: 12px;
  }
</style>
